"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _editabletext_styles = _interopRequireDefault(require("./editabletext_styles"));

var _editabletext_definition = _interopRequireDefault(require("./editabletext_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : EDITABLE TEXT ~~~~~~~~~~ ========== */


var EditableText =
/*#__PURE__*/
function (_Component) {
  _inherits(EditableText, _Component);

  function EditableText(_props) {
    var _this;

    _classCallCheck(this, EditableText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditableText).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (_this.props.onKeyDown !== undefined) {
        _this.props.onKeyDown(e.target.textContent, (0, _utils.getElementCSSProperty)(e.target, 'height'));
      }

      if (_this.props.preventEnterOnKeyDown && e.which === 13) {
        e.preventDefault();
        return false;
      } // check if we've hit character limit (passed in as prop)


      if (_this.props.characterLimit !== undefined && e.target.textContent.length >= _this.props.characterLimit && e.key.length === 1) {
        e.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (e) {
      if (_this.props.onKeyUp !== undefined) {
        _this.props.onKeyUp(e.target.textContent, (0, _utils.getElementCSSProperty)(e.target, 'height'));
      }

      _this.setCharacterCount(e.target.textContent); // needed to dynamically resize text via classes and callback functions


      if (_this.props.onTextEdit !== undefined) {
        _this.props.onTextEdit(e.target.textContent, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      if (_this.props.onFocus !== undefined) {
        _this.props.onFocus(e.target.textContent, (0, _utils.getElementCSSProperty)(e.target, 'height'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      if (_this.props.onBlur === undefined) return null; // Trigger children's onBlur method

      _this.props.onBlur(e.target.textContent, (0, _utils.getElementCSSProperty)(e.target, 'height')); // Update text in the application state
      // const trimmedText = e.target.textContent !==null && e.target.textContent.trim().length > 0 ? e.target.textContent.trim(): null;
      // this.pushTextToStore(trimmedText)

    });

    _defineProperty(_assertThisInitialized(_this), "handlePaste", function (e) {
      e.preventDefault();
      var text = e.clipboardData.getData('text/plain'); // This will prevent users from pasting more than allowed characters in the div

      if (_this.props.characterLimit !== undefined && typeof _this.props.characterLimit === 'number') {
        text = e.clipboardData.getData('text/plain').slice(0, _this.props.characterLimit - e.target.textContent.length);
      }

      var temp = document.createElement('div');
      temp.innerHTML = text;
      document.execCommand('insertHTML', false, temp.textContent);
    });

    _defineProperty(_assertThisInitialized(_this), "setCharacterCount", function (text) {
      var characterCount = typeof text === 'string' ? text.length : 0;
      if (_this.props.isEditable && _this.state.characterCount !== characterCount) _this.setState({
        characterCount: characterCount
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getLimitClass", function () {
      if (!_this.props.isEditable) return 'none';
      if (typeof _this.props.characterLimit !== 'number' || typeof _this.state.characterCount !== 'number' || _this.props.characterLimit === 0) return 'none';
      var fillRate = _this.state.characterCount / _this.props.characterLimit;
      return _this.props.characterLimit === _this.state.characterCount ? 'reached' : fillRate >= 0.85 ? 'approaching' : 'none';
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialCharacterCount", function (props) {
      return typeof props.defaultText === 'string' ? props.defaultText.length : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderCharacterCount", function () {
      return _this.props.showCharacterCount && _this.props.characterLimit > 0 ? _react.default.createElement("div", {
        className: "charactercount limit-".concat(_this.getLimitClass())
      }, "".concat(_this.state.characterCount, "/").concat(_this.props.characterLimit)) : null;
    });

    _this.editableEl = null;
    _this.state = {
      characterCount: _this.getInitialCharacterCount(_props)
    };
    return _this;
  }

  _createClass(EditableText, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.defaultText !== this.props.defaultText) {
        this.setCharacterCount(this.props.defaultText);
        this.props.validateText(this.props.defaultText);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.isEditable) {
        this.editableEl.blur(); // this.pushTextToStore(this.editableEl.innerText);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        className: " ".concat(this.props.classes.editabletextwrapper, " editabletextwrapper")
      }, this._renderCharacterCount(), _react.default.createElement("div", {
        ref: function ref(e) {
          if (e != null) {
            _this2.editableEl = e;
            e.contentEditable = _this2.props.isEditable;
          }
        },
        style: this.props.style,
        className: "editabletext",
        "data-text": this.props.placeholder,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onPaste: this.handlePaste
      }, this.props.defaultText));
    }
  }]);

  return EditableText;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(EditableText, _editabletext_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_editabletext_styles.default)(EditableText);

exports.default = _default;